import { Container } from '@mui/material';
import { EditResource } from 'components/templates';

export const EditResourceView = () => {
  return (
    <Container>
      <EditResource />
    </Container>
  );
};
